import Helper from "./Helper";

class RelevanceMatrix {
  constructor(config = {}) {
    const { idName, className } = config;

    this.idName = idName;
    this.className = className;

    const matrices = Array.prototype.slice.call(document.querySelectorAll('.ns-relevance-matrix'));
    /* console.log(matrices); */

    matrices.forEach(matrix => {
      const toggles = Array.prototype.slice.call(
        matrix.querySelectorAll(`g[id*="${this.idName}"]`)
      );

       /* console.log(toggles); */

      toggles.forEach(toggle => {
        toggle.addEventListener("click", () => {
          const toggleNum = toggle.id.replace(this.idName, "");
          const popup = matrix.querySelector(`.${className}${toggleNum}`);

          Helper.addClass(popup, "is-visible");
          // Helper.addClass(document.querySelector("body"), "notes-open");
          setTimeout(() => {
            Helper.addClass(popup, "fade-in");
          }, 300);
        });
      });
    });
  }
}

export default RelevanceMatrix;
